<script lang="ts">
    import route from '../Util/routes';
    import ToggleButtonSmall from '../Bootstrap/ToggleButtonSmall.svelte'
    import { round, getFlags, createSectionSave } from '@/Util/utils';

    export let profileParams;

     let hr_options = {enable_hr_xss_estimation:true, auto_calc_hr_params:false}
    $: setHrOptions(profileParams?.user_attributes);
     function setHrOptions(value){
        hr_options.enable_hr_xss_estimation = (value?.enable_hr_xss_estimation ?? false)
        hr_options.auto_calc_hr_params = (value?.auto_calc_hr_params ?? false)
        section?.markSaved()   // the server's values (also when they come back recalculated) are what is saved

    }

     let hr_params = {hr_resting:0, hr_max:0}
     function setHrParams(value){
        hr_params.hr_resting = round(value.hr_resting,0)
        hr_params.hr_max = round(value.hr_max,0)
        section?.markSaved()
        
    }
    $: setHrParams(profileParams?.hr_params);   
    
    
    function getBody(){
        return {
            ...hr_params,
            ...getFlags(hr_options),
        }
    }
    const postHeartRateDerivedMetrics = route('UserController@postHeartRateDerivedMetrics');
    // Only what has been edited is saved (createSectionSave)
    const section = createSectionSave(postHeartRateDerivedMetrics, getBody, "Heart Rate Derived Metrics could not be saved.")
    const { saved } = section
    // Whether it has been edited since it was loaded or last saved, for the page's Save button
    export let changed = false
    $: changed = section.isChanged($saved, hr_params, hr_options)
    export const submitHandler = section.submit


</script>

<div class="flex flex-col portlet light bordered full-height-content full-height-content-scrollable p-4 border-2">
    <h4 class="mb-6">Heart Rate Derived Metrics</h4>
    <div class='col-md col-md-8 col-xs-12 mb-2 flex flex-row gap-2'>
        <ToggleButtonSmall bind:isChecked={hr_options.enable_hr_xss_estimation} label={"Enable the estimation of Xert Metrics like XSS and Focus using Heart Rate"} ></ToggleButtonSmall>
        <a href="https://www.baronbiosys.com/glossary/heart-rate-derived-metrics" target="_help">
            <div class="tooltip-icon">
                <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
            </div>
        </a>
    </div>
    {#if hr_options.enable_hr_xss_estimation}
        <div id="hr_params_row" class="col-md col-md-8 col-xs-12">
            <ToggleButtonSmall bind:isChecked={hr_options.auto_calc_hr_params} label={"Auto-estimate Heart Rate parameters"} ></ToggleButtonSmall>
            <div class="row mt-3">
                <div class="col-md-4 col-md-4 col-xs-12">
                    <label class="hr-resting">Resting Heart Rate</label>
                    <div class="form-group">
                        <div class="input-icon">
                            <i class="fa fa-bolt hr-resting"></i>
                            <input name="hr_resting" id="hr_resting" type="number" bind:value={hr_params.hr_resting} min='0' step="1" class="form-control input-circle-right" placeholder="BPM" disabled={hr_options.auto_calc_hr_params}> </div>
                        <span class="help-block"><small>In BPM.</small></span>
                    </div>
                </div>
                <div class="col-md-4 col-xs-12">
                    <label class="hr-max">Maximum Heart Rate </label>
                    <div class="form-group">
                        <div class="input-icon">
                            <i class="fa fa-bolt hr_max"></i>
                            <input name="hr_max" id="hr_max" type="number" bind:value={hr_params.hr_max} min='0' step="1" class="form-control input-circle-right" placeholder="BPM" disabled={hr_options.auto_calc_hr_params}> </div>
                        <span class="help-block"><small>In BPM.</small></span>
                    </div>
                </div>
            </div>
        </div>
    {/if}
    <!-- <button class="btn green-haze ml-auto" on:click={submitHandler} >Save</button> -->
</div>

<style lang="scss">

    .input-icon {
        align-content: center;
        > input{
            padding-left:30px !important;
            padding-right:-30px !important;
            margin-right:8px !important;
        }
        > i{
            margin: 8px 0 0 8px !important;
        }
    }

    .form-group{
        flex-grow:1;
        min-width:100px;
    }

    tr {
        height: 40px;
    }

    td {
        max-width: 125px;
        min-width:100px
    }

    label.mt-checkbox {
        margin:0;
    }
</style>